import { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { ProviderIcon } from '@/components/icons/ProviderIcon';

const PROVIDER_META: Record<string, { label: string; color: string }> = {
    google: { label: 'Google', color: 'bg-white text-black hover:bg-gray-100' },
    discord: { label: 'Discord', color: 'bg-[#5865F2] hover:bg-[#4752C4] text-white' },
    github: { label: 'GitHub', color: 'bg-[#24292e] hover:bg-[#1a1e22] text-white' },
    twitter: { label: 'X / Twitter', color: 'bg-black hover:bg-gray-900 text-white border border-slate-700' },
    microsoft: { label: 'Microsoft', color: 'bg-[#2F2F2F] hover:bg-[#1a1a1a] text-white' },
};

export function SocialAuthButtons() {
    const [providers, setProviders] = useState<string[]>([]);
    const [loading, setLoading] = useState<string | null>(null);

    useEffect(() => {
        api.get<{ providers: string[] }>('/auth/providers').then((res) => {
            setProviders(res.providers);
        }).catch(() => {});
    }, []);

    const handleSocialLogin = async (provider: string) => {
        setLoading(provider);
        try {
            const res = await api.get<{ url: string }>(`/auth/${provider}/redirect`);
            window.location.href = res.url;
        } catch {
            setLoading(null);
        }
    };

    if (providers.length === 0) return null;

    return (
        <div className="space-y-3">
            <div className="relative">
                <div className="absolute inset-0 flex items-center">
                    <span className="w-full border-t border-slate-700" />
                </div>
                <div className="relative flex justify-center text-xs uppercase">
                    <span className="bg-slate-900 px-2 text-slate-500">Or continue with</span>
                </div>
            </div>
            <div className="grid gap-2">
                {providers.map((provider) => {
                    const meta = PROVIDER_META[provider];
                    if (!meta) return null;
                    return (
                        <Button
                            key={provider}
                            type="button"
                            variant="outline"
                            className={`w-full ${meta.color}`}
                            onClick={() => handleSocialLogin(provider)}
                            disabled={loading !== null}
                        >
                            <ProviderIcon provider={provider} className="mr-2 h-4 w-4" />
                            {loading === provider ? 'Redirecting...' : meta.label}
                        </Button>
                    );
                })}
            </div>
        </div>
    );
}
